// Documentação dos componentes do sistema Altus Food

export interface ComponentDoc {
  name: string;
  path: string;
  description: string;
  props?: { name: string; type: string; description: string; required?: boolean }[];
}

export interface ComponentModule {
  name: string;
  path: string;
  description: string;
  components: ComponentDoc[];
}

export const COMPONENT_MODULES: ComponentModule[] = [
  {
    name: "PDV (Ponto de Venda)",
    path: "src/components/pdv/",
    description: "Componentes da interface do caixa/PDV para lançamento de pedidos.",
    components: [
      { name: "CartSidebar", path: "CartSidebar.tsx", description: "Sidebar com carrinho de itens antes de enviar para cozinha" },
      { name: "ProductGrid", path: "ProductGrid.tsx", description: "Grid de produtos para seleção rápida" },
      { name: "CategoryGrid", path: "CategoryGrid.tsx", description: "Grid de categorias para filtro" },
      { name: "CategoryTabs", path: "CategoryTabs.tsx", description: "Tabs de categorias horizontais" },
      { name: "CheckoutDialog", path: "CheckoutDialog.tsx", description: "Dialog de fechamento de conta" },
      { name: "CheckoutScreen", path: "CheckoutScreen.tsx", description: "Tela completa de checkout" },
      { name: "PDVActionBar", path: "PDVActionBar.tsx", description: "Barra de ações do PDV" },
      { name: "PDVItemsList", path: "PDVItemsList.tsx", description: "Lista de itens do pedido atual" },
      { name: "PDVOrderHeader", path: "PDVOrderHeader.tsx", description: "Cabeçalho com info da mesa/comanda" },
      { name: "PDVSelectionScreen", path: "PDVSelectionScreen.tsx", description: "Tela de seleção de mesa/comanda" },
      { name: "PartialPaymentDialog", path: "PartialPaymentDialog.tsx", description: "Dialog para pagamento parcial" },
      { name: "PeopleCountDialog", path: "PeopleCountDialog.tsx", description: "Dialog para número de pessoas" },
      { name: "ItemNotesDialog", path: "ItemNotesDialog.tsx", description: "Dialog para observações do item" },
      { name: "CancelSentItemDialog", path: "CancelSentItemDialog.tsx", description: "Dialog para cancelar item enviado" },
      { name: "OfflineBanner", path: "OfflineBanner.tsx", description: "Banner de modo offline" },
      { name: "OfflineStatusIndicator", path: "OfflineStatusIndicator.tsx", description: "Indicador de status offline" },
      { name: "SQLiteStatusIndicator", path: "SQLiteStatusIndicator.tsx", description: "Indicador de SQLite local" },
      { name: "CashRegisterClosedOverlay", path: "CashRegisterClosedOverlay.tsx", description: "Overlay quando caixa fechado" },
      { name: "PeriodClosedOverlay", path: "PeriodClosedOverlay.tsx", description: "Overlay quando período fechado" },
    ],
  },
  {
    name: "Mesas",
    path: "src/components/tables/",
    description: "Componentes para gerenciamento de mesas.",
    components: [
      { name: "TableCard", path: "TableCard.tsx", description: "Card visual de mesa com status" },
      { name: "TableMapView", path: "TableMapView.tsx", description: "Visualização do mapa de mesas" },
      { name: "TableFormDialog", path: "TableFormDialog.tsx", description: "Dialog para criar/editar mesa" },
      { name: "BatchTableDialog", path: "BatchTableDialog.tsx", description: "Dialog para criar mesas em lote" },
      { name: "TableNicknameDialog", path: "TableNicknameDialog.tsx", description: "Dialog para definir apelido" },
    ],
  },
  {
    name: "Pedidos",
    path: "src/components/orders/",
    description: "Componentes para listagem e detalhes de pedidos.",
    components: [
      { name: "OrdersTable", path: "OrdersTable.tsx", description: "Tabela de pedidos com paginação" },
      { name: "OrderDetailsDialog", path: "OrderDetailsDialog.tsx", description: "Dialog com detalhes do pedido" },
      { name: "OrderFilters", path: "OrderFilters.tsx", description: "Filtros de busca de pedidos" },
      { name: "OrderStatusBadge", path: "OrderStatusBadge.tsx", description: "Badge de status do pedido" },
    ],
  },
  {
    name: "Produtos",
    path: "src/components/products/",
    description: "Componentes para cadastro de produtos.",
    components: [
      { name: "ProductList", path: "ProductList.tsx", description: "Lista de produtos com busca" },
      { name: "ProductFormDialog", path: "ProductFormDialog.tsx", description: "Dialog para criar/editar produto" },
      { name: "ProductImageUpload", path: "ProductImageUpload.tsx", description: "Upload de imagem do produto" },
      { name: "ProductRecipeDialog", path: "ProductRecipeDialog.tsx", description: "Dialog de ficha técnica" },
      { name: "PriceHistoryDialog", path: "PriceHistoryDialog.tsx", description: "Histórico de preços" },
    ],
  },
  {
    name: "Categorias",
    path: "src/components/categories/",
    description: "Componentes para gerenciamento de categorias.",
    components: [
      { name: "CategoryList", path: "CategoryList.tsx", description: "Lista de categorias reordenável" },
      { name: "CategoryFormDialog", path: "CategoryFormDialog.tsx", description: "Dialog para criar/editar" },
    ],
  },
  {
    name: "Combos",
    path: "src/components/combos/",
    description: "Componentes para montagem de combos e promoções.",
    components: [
      { name: "ComboFormDialog", path: "ComboFormDialog.tsx", description: "Dialog para criar combo" },
      { name: "ComboBasicFormDialog", path: "ComboBasicFormDialog.tsx", description: "Form básico do combo" },
      { name: "ComboDetailSheet", path: "ComboDetailSheet.tsx", description: "Sheet com detalhes do combo" },
      { name: "ComboSlotsSheet", path: "ComboSlotsSheet.tsx", description: "Sheet para gerenciar slots" },
      { name: "ComboSlotFormDialog", path: "ComboSlotFormDialog.tsx", description: "Dialog para criar slot" },
    ],
  },
  {
    name: "Caixa",
    path: "src/components/cash-register/",
    description: "Componentes de gestão de caixa.",
    components: [
      { name: "OpenCashRegisterDialog", path: "OpenCashRegisterDialog.tsx", description: "Dialog para abrir caixa" },
      { name: "CloseCashRegisterDialog", path: "CloseCashRegisterDialog.tsx", description: "Dialog para fechar caixa" },
      { name: "CashMovementDialog", path: "CashMovementDialog.tsx", description: "Dialog para sangria/suprimento" },
      { name: "CashMovementsList", path: "CashMovementsList.tsx", description: "Lista de movimentações" },
      { name: "CashCountForm", path: "CashCountForm.tsx", description: "Formulário de contagem" },
      { name: "CashRegisterReportDialog", path: "CashRegisterReportDialog.tsx", description: "Relatório do caixa" },
      { name: "PeriodStatusCard", path: "PeriodStatusCard.tsx", description: "Card de status do período" },
      { name: "ClosePeriodDialog", path: "ClosePeriodDialog.tsx", description: "Dialog para fechar período" },
    ],
  },
  {
    name: "Estoque",
    path: "src/components/stock/",
    description: "Componentes de controle de estoque.",
    components: [
      { name: "IngredientList", path: "IngredientList.tsx", description: "Lista de ingredientes" },
      { name: "IngredientFormDialog", path: "IngredientFormDialog.tsx", description: "Dialog criar/editar ingrediente" },
      { name: "StockMovementDialog", path: "StockMovementDialog.tsx", description: "Dialog de movimentação" },
      { name: "StockMovementsList", path: "StockMovementsList.tsx", description: "Lista de movimentações" },
      { name: "StockMovementsFilters", path: "StockMovementsFilters.tsx", description: "Filtros de movimentação" },
      { name: "LowStockAlert", path: "LowStockAlert.tsx", description: "Alerta de estoque baixo" },
      { name: "ProductStockList", path: "ProductStockList.tsx", description: "Lista de estoque de produtos" },
      { name: "ProductStockMovementDialog", path: "ProductStockMovementDialog.tsx", description: "Movimento de produto" },
    ],
  },
  {
    name: "Despesas",
    path: "src/components/expenses/",
    description: "Componentes de gestão de despesas.",
    components: [
      { name: "ExpenseFormDialog", path: "ExpenseFormDialog.tsx", description: "Dialog criar/editar despesa" },
      { name: "ExpenseCategoryFormDialog", path: "ExpenseCategoryFormDialog.tsx", description: "Dialog de categoria" },
      { name: "ExpenseStatusBadge", path: "ExpenseStatusBadge.tsx", description: "Badge de status" },
      { name: "ExpenseLinkFields", path: "ExpenseLinkFields.tsx", description: "Campos de vínculo" },
      { name: "MarkExpensePaidDialog", path: "MarkExpensePaidDialog.tsx", description: "Dialog marcar como paga" },
    ],
  },
  {
    name: "Impressoras",
    path: "src/components/printers/",
    description: "Componentes de configuração de impressoras.",
    components: [
      { name: "PrinterList", path: "PrinterList.tsx", description: "Lista de impressoras" },
      { name: "PrinterFormDialog", path: "PrinterFormDialog.tsx", description: "Dialog criar/editar" },
      { name: "PrinterConnectionTest", path: "PrinterConnectionTest.tsx", description: "Teste de conexão" },
      { name: "PrinterStatusIndicator", path: "PrinterStatusIndicator.tsx", description: "Indicador de status" },
      { name: "PrintQueueMonitor", path: "PrintQueueMonitor.tsx", description: "Monitor da fila" },
      { name: "QZTraySetupGuide", path: "QZTraySetupGuide.tsx", description: "Guia de configuração QZ" },
    ],
  },
  {
    name: "Locais de Produção",
    path: "src/components/production-locations/",
    description: "Componentes para setores de produção.",
    components: [
      { name: "ProductionLocationList", path: "ProductionLocationList.tsx", description: "Lista de locais" },
      { name: "ProductionLocationFormDialog", path: "ProductionLocationFormDialog.tsx", description: "Dialog criar/editar" },
      { name: "PrinterTestCard", path: "PrinterTestCard.tsx", description: "Card de teste de impressora" },
    ],
  },
  {
    name: "Fiscal",
    path: "src/components/fiscal/",
    description: "Componentes do módulo fiscal (NFC-e).",
    components: [
      { name: "FiscalConfigCard", path: "FiscalConfigCard.tsx", description: "Card de configuração fiscal" },
      { name: "FiscalSetupGuide", path: "FiscalSetupGuide.tsx", description: "Guia de configuração" },
      { name: "EmitterDataForm", path: "EmitterDataForm.tsx", description: "Formulário dados emitente" },
      { name: "NfceEmissionDialog", path: "NfceEmissionDialog.tsx", description: "Dialog de emissão NFC-e" },
      { name: "NfceHistoryList", path: "NfceHistoryList.tsx", description: "Histórico de NFC-e" },
      { name: "ProductFiscalList", path: "ProductFiscalList.tsx", description: "Lista dados fiscais produtos" },
      { name: "ProductFiscalEditDialog", path: "ProductFiscalEditDialog.tsx", description: "Editar dados fiscais" },
      { name: "ProductFiscalBatchDialog", path: "ProductFiscalBatchDialog.tsx", description: "Edição em lote" },
      { name: "TaxRuleList", path: "TaxRuleList.tsx", description: "Lista de regras fiscais" },
      { name: "TaxRuleFormDialog", path: "TaxRuleFormDialog.tsx", description: "Dialog de regra fiscal" },
      { name: "AcbrConnectionTest", path: "AcbrConnectionTest.tsx", description: "Teste conexão ACBr" },
      { name: "CustomerIdentificationDialog", path: "CustomerIdentificationDialog.tsx", description: "CPF na nota" },
    ],
  },
  {
    name: "Relatórios",
    path: "src/components/reports/",
    description: "Componentes de gráficos e relatórios.",
    components: [
      { name: "SalesChart", path: "SalesChart.tsx", description: "Gráfico de vendas" },
      { name: "CategorySalesChart", path: "CategorySalesChart.tsx", description: "Vendas por categoria" },
      { name: "PaymentMethodsChart", path: "PaymentMethodsChart.tsx", description: "Formas de pagamento" },
      { name: "TopProductsTable", path: "TopProductsTable.tsx", description: "Produtos mais vendidos" },
      { name: "TopCombosTable", path: "TopCombosTable.tsx", description: "Combos mais vendidos" },
      { name: "DRETable", path: "DRETable.tsx", description: "Tabela DRE" },
      { name: "DRESummaryCards", path: "DRESummaryCards.tsx", description: "Cards resumo DRE" },
      { name: "CMVChart", path: "CMVChart.tsx", description: "Gráfico CMV" },
      { name: "CMVDetailChart", path: "CMVDetailChart.tsx", description: "CMV detalhado" },
      { name: "CMOChart", path: "CMOChart.tsx", description: "Gráfico CMO" },
      { name: "TicketMedioChart", path: "TicketMedioChart.tsx", description: "Ticket médio" },
      { name: "NetProfitEvolutionChart", path: "NetProfitEvolutionChart.tsx", description: "Evolução lucro" },
      { name: "ExpenseCompositionChart", path: "ExpenseCompositionChart.tsx", description: "Composição despesas" },
      { name: "ComboSalesChart", path: "ComboSalesChart.tsx", description: "Vendas de combos" },
    ],
  },
  {
    name: "Dashboard",
    path: "src/components/dashboard/",
    description: "Componentes do dashboard principal.",
    components: [
      { name: "SalesGoalCard", path: "SalesGoalCard.tsx", description: "Card de meta de vendas" },
      { name: "HourlySalesChart", path: "HourlySalesChart.tsx", description: "Vendas por hora" },
      { name: "WeeklyTrendChart", path: "WeeklyTrendChart.tsx", description: "Tendência semanal" },
      { name: "PrinterStatusCard", path: "PrinterStatusCard.tsx", description: "Status das impressoras" },
    ],
  },
  {
    name: "Menu Público (QR Code)",
    path: "src/components/public/",
    description: "Componentes do cardápio digital para clientes.",
    components: [
      { name: "PublicProductCard", path: "PublicProductCard.tsx", description: "Card de produto" },
      { name: "PublicComboCard", path: "PublicComboCard.tsx", description: "Card de combo" },
      { name: "ProductDetailSheet", path: "ProductDetailSheet.tsx", description: "Detalhes do produto" },
      { name: "PublicComboDetailSheet", path: "PublicComboDetailSheet.tsx", description: "Detalhes do combo" },
      { name: "PublicCart", path: "PublicCart.tsx", description: "Carrinho do cliente" },
      { name: "PublicCheckoutDialog", path: "PublicCheckoutDialog.tsx", description: "Checkout do cliente" },
      { name: "TableBillSection", path: "TableBillSection.tsx", description: "Seção da conta" },
      { name: "CallWaiterButton", path: "CallWaiterButton.tsx", description: "Botão chamar garçom" },
      { name: "QRCodeGenerator", path: "QRCodeGenerator.tsx", description: "Gerador de QR Code" },
    ],
  },
  {
    name: "Tablet (Totem/Autoatendimento)",
    path: "src/components/tablet/",
    description: "Componentes para tablets de autoatendimento.",
    components: [
      { name: "TabletHeader", path: "TabletHeader.tsx", description: "Header do tablet" },
      { name: "TabletSidebar", path: "TabletSidebar.tsx", description: "Sidebar do tablet" },
      { name: "TabletCategoryList", path: "TabletCategoryList.tsx", description: "Lista de categorias" },
      { name: "TabletProductGrid", path: "TabletProductGrid.tsx", description: "Grid de produtos" },
      { name: "TabletProductCard", path: "TabletProductCard.tsx", description: "Card de produto" },
      { name: "TabletProductDetailSheet", path: "TabletProductDetailSheet.tsx", description: "Detalhes produto" },
      { name: "TabletCart", path: "TabletCart.tsx", description: "Carrinho do tablet" },
      { name: "TabletBillSection", path: "TabletBillSection.tsx", description: "Seção da conta" },
      { name: "TabletHighlightsSection", path: "TabletHighlightsSection.tsx", description: "Destaques" },
      { name: "TabletBannersManager", path: "TabletBannersManager.tsx", description: "Gerenciador banners" },
      { name: "BannerFormDialog", path: "BannerFormDialog.tsx", description: "Dialog de banner" },
      { name: "TabletScreensaver", path: "TabletScreensaver.tsx", description: "Protetor de tela" },
      { name: "TabletSetupScreen", path: "TabletSetupScreen.tsx", description: "Tela de setup" },
      { name: "TabletTableSelector", path: "TabletTableSelector.tsx", description: "Seletor de mesa" },
      { name: "TabletRatingScreen", path: "TabletRatingScreen.tsx", description: "Tela de avaliação" },
      { name: "TabletKioskUnlockDialog", path: "TabletKioskUnlockDialog.tsx", description: "Desbloqueio kiosk" },
      { name: "TabletInstallInstructions", path: "TabletInstallInstructions.tsx", description: "Instruções PWA" },
      { name: "LandscapeWarning", path: "LandscapeWarning.tsx", description: "Aviso orientação" },
    ],
  },
  {
    name: "Garçom",
    path: "src/components/garcom/",
    description: "Componentes para interface do garçom.",
    components: [
      { name: "WaiterCheckinScreen", path: "WaiterCheckinScreen.tsx", description: "Tela de check-in" },
      { name: "GarcomProductGrid", path: "GarcomProductGrid.tsx", description: "Grid de produtos" },
      { name: "GarcomComboGrid", path: "GarcomComboGrid.tsx", description: "Grid de combos" },
      { name: "SessionStatusBadge", path: "SessionStatusBadge.tsx", description: "Badge status sessão" },
      { name: "ConnectionStatusIndicator", path: "ConnectionStatusIndicator.tsx", description: "Status conexão" },
    ],
  },
  {
    name: "Comandas",
    path: "src/components/commands/",
    description: "Componentes de gerenciamento de comandas.",
    components: [
      { name: "CommandCard", path: "CommandCard.tsx", description: "Card de comanda" },
      { name: "CommandFormDialog", path: "CommandFormDialog.tsx", description: "Dialog criar comanda" },
      { name: "BatchCommandDialog", path: "BatchCommandDialog.tsx", description: "Criar em lote" },
      { name: "ManageEntryDialog", path: "ManageEntryDialog.tsx", description: "Gerenciar entrada" },
    ],
  },
  {
    name: "Consumo Aberto",
    path: "src/components/open-consumption/",
    description: "Componentes para visualização de consumos.",
    components: [
      { name: "OpenConsumptionCard", path: "OpenConsumptionCard.tsx", description: "Card de consumo" },
      { name: "OpenConsumptionDetailsDialog", path: "OpenConsumptionDetailsDialog.tsx", description: "Detalhes" },
      { name: "CloseConsumptionDialog", path: "CloseConsumptionDialog.tsx", description: "Fechar consumo" },
      { name: "TransferItemDialog", path: "TransferItemDialog.tsx", description: "Transferir item" },
    ],
  },
  {
    name: "Formas de Pagamento",
    path: "src/components/payment-methods/",
    description: "Componentes de formas de pagamento.",
    components: [
      { name: "PaymentMethodList", path: "PaymentMethodList.tsx", description: "Lista de formas" },
      { name: "PaymentMethodFormDialog", path: "PaymentMethodFormDialog.tsx", description: "Dialog criar/editar" },
    ],
  },
  {
    name: "Equipe",
    path: "src/components/team/",
    description: "Componentes de gestão de equipe.",
    components: [
      { name: "TeamMemberCard", path: "TeamMemberCard.tsx", description: "Card de membro" },
      { name: "AddTeamMemberDialog", path: "AddTeamMemberDialog.tsx", description: "Adicionar membro" },
      { name: "TeamMemberEditDialog", path: "TeamMemberEditDialog.tsx", description: "Editar membro" },
    ],
  },
  {
    name: "Fornecedores",
    path: "src/components/suppliers/",
    description: "Componentes de gestão de fornecedores.",
    components: [
      { name: "SupplierList", path: "SupplierList.tsx", description: "Lista de fornecedores" },
      { name: "SupplierFormDialog", path: "SupplierFormDialog.tsx", description: "Dialog criar/editar" },
      { name: "SupplierFormFields", path: "SupplierFormFields.tsx", description: "Campos do formulário" },
      { name: "SupplierQuickCreateDialog", path: "SupplierQuickCreateDialog.tsx", description: "Criação rápida" },
    ],
  },
  {
    name: "Plano de Contas",
    path: "src/components/chart-of-accounts/",
    description: "Componentes do plano de contas.",
    components: [
      { name: "AccountTree", path: "AccountTree.tsx", description: "Árvore hierárquica" },
      { name: "AccountFormDialog", path: "AccountFormDialog.tsx", description: "Dialog criar/editar" },
    ],
  },
  {
    name: "Notificações",
    path: "src/components/notifications/",
    description: "Componentes de notificações.",
    components: [
      { name: "NotificationBell", path: "NotificationBell.tsx", description: "Sino de notificações" },
      { name: "PushNotificationToggle", path: "PushNotificationToggle.tsx", description: "Toggle push" },
      { name: "PublicOrderNotificationPanel", path: "PublicOrderNotificationPanel.tsx", description: "Painel pedidos" },
      { name: "WaiterCallNotificationPanel", path: "WaiterCallNotificationPanel.tsx", description: "Painel chamadas" },
    ],
  },
  {
    name: "PWA",
    path: "src/components/pwa/",
    description: "Componentes de Progressive Web App.",
    components: [
      { name: "InstallPrompt", path: "InstallPrompt.tsx", description: "Prompt de instalação" },
      { name: "InstallButton", path: "InstallButton.tsx", description: "Botão instalar" },
      { name: "PWAInstructions", path: "PWAInstructions.tsx", description: "Instruções PWA" },
      { name: "VersionUpdateBanner", path: "VersionUpdateBanner.tsx", description: "Banner atualização" },
      { name: "PullToRefreshIndicator", path: "PullToRefreshIndicator.tsx", description: "Indicador pull" },
    ],
  },
  {
    name: "Configurações",
    path: "src/components/settings/",
    description: "Componentes de configurações gerais.",
    components: [
      { name: "TableManagementCard", path: "TableManagementCard.tsx", description: "Card mesas" },
      { name: "CommandManagementCard", path: "CommandManagementCard.tsx", description: "Card comandas" },
      { name: "EntryTypesCard", path: "EntryTypesCard.tsx", description: "Card tipos entrada" },
      { name: "QZTrayConfigCard", path: "QZTrayConfigCard.tsx", description: "Config QZ Tray" },
      { name: "PrintTemplateSettings", path: "PrintTemplateSettings.tsx", description: "Templates impressão" },
      { name: "ReceiptPreview", path: "ReceiptPreview.tsx", description: "Preview do cupom" },
      { name: "BackupCard", path: "BackupCard.tsx", description: "Card de backup" },
      { name: "AutoClosePeriodCard", path: "AutoClosePeriodCard.tsx", description: "Auto fechar período" },
      { name: "TableConsumptionSettingsCard", path: "TableConsumptionSettingsCard.tsx", description: "Config consumo mesa" },
      { name: "CancellationPrintSettingsCard", path: "CancellationPrintSettingsCard.tsx", description: "Config cancelamento" },
      { name: "TransferPendingConsumptionCard", path: "TransferPendingConsumptionCard.tsx", description: "Transferir pendentes" },
    ],
  },
  {
    name: "UI Base (shadcn)",
    path: "src/components/ui/",
    description: "Componentes base do design system (shadcn/ui).",
    components: [
      { name: "Button", path: "button.tsx", description: "Botão com variantes" },
      { name: "Card", path: "card.tsx", description: "Card container" },
      { name: "Dialog", path: "dialog.tsx", description: "Modal dialog" },
      { name: "Sheet", path: "sheet.tsx", description: "Painel lateral" },
      { name: "Form", path: "form.tsx", description: "Wrapper de formulário" },
      { name: "Input", path: "input.tsx", description: "Campo de texto" },
      { name: "Select", path: "select.tsx", description: "Dropdown select" },
      { name: "Table", path: "table.tsx", description: "Tabela de dados" },
      { name: "Tabs", path: "tabs.tsx", description: "Navegação por abas" },
      { name: "Badge", path: "badge.tsx", description: "Badge/tag" },
      { name: "Alert", path: "alert.tsx", description: "Alerta" },
      { name: "Toast", path: "toast.tsx", description: "Notificação toast" },
      { name: "Skeleton", path: "skeleton.tsx", description: "Loading skeleton" },
      { name: "Popover", path: "popover.tsx", description: "Popover flutuante" },
      { name: "Dropdown", path: "dropdown-menu.tsx", description: "Menu dropdown" },
      { name: "Command", path: "command.tsx", description: "Command palette" },
      { name: "Calendar", path: "calendar.tsx", description: "Calendário" },
      { name: "Checkbox", path: "checkbox.tsx", description: "Checkbox" },
      { name: "Switch", path: "switch.tsx", description: "Toggle switch" },
      { name: "Slider", path: "slider.tsx", description: "Slider range" },
      { name: "Progress", path: "progress.tsx", description: "Barra de progresso" },
      { name: "Avatar", path: "avatar.tsx", description: "Avatar de usuário" },
      { name: "Sidebar", path: "sidebar.tsx", description: "Sidebar navigation" },
      { name: "ScrollArea", path: "scroll-area.tsx", description: "Área com scroll" },
      { name: "Separator", path: "separator.tsx", description: "Separador visual" },
      { name: "Tooltip", path: "tooltip.tsx", description: "Tooltip hover" },
      { name: "Accordion", path: "accordion.tsx", description: "Accordion expandível" },
      { name: "Collapsible", path: "collapsible.tsx", description: "Seção colapsável" },
    ],
  },
  {
    name: "Layout",
    path: "src/layouts/",
    description: "Componentes de layout da aplicação.",
    components: [
      { name: "DashboardLayout", path: "DashboardLayout.tsx", description: "Layout do dashboard" },
      { name: "AdminLayout", path: "AdminLayout.tsx", description: "Layout do painel admin" },
    ],
  },
  {
    name: "Outros",
    path: "src/components/",
    description: "Componentes diversos.",
    components: [
      { name: "AppSidebar", path: "AppSidebar.tsx", description: "Sidebar principal" },
      { name: "NavLink", path: "NavLink.tsx", description: "Link de navegação" },
      { name: "ErrorBoundary", path: "ErrorBoundary.tsx", description: "Boundary de erro" },
      { name: "LogoUpload", path: "LogoUpload.tsx", description: "Upload de logo" },
      { name: "WhatsAppButton", path: "WhatsAppButton.tsx", description: "Botão WhatsApp" },
      { name: "RealtimeIndicator", path: "RealtimeIndicator.tsx", description: "Indicador realtime" },
    ],
  },
];

// Helper para buscar módulo por nome
export function getModuleByName(name: string): ComponentModule | undefined {
  return COMPONENT_MODULES.find(m => m.name === name);
}

// Total de componentes
export function getTotalComponentsCount(): number {
  return COMPONENT_MODULES.reduce((acc, m) => acc + m.components.length, 0);
}
